module.exports = __webpack_public_path__ + "static/media/forrestSpirit.c66b8fcb.png";